import { createApp } from 'vue'
import router from './router'
import store from './store'

import './main.scss'
import './assets/tailwind.css'

import App from './App.vue'
import dcode from 'dcode/init'
import Translation from 'dcode/classes/Translation'
import ApiSite from '@/classes/ApiSite'
// import VueGtag from 'vue-gtag'

(async () => {
  Translation.add(await ApiSite.getTranslation())
})().then(() => {
  createApp(App)
    .use(store)
    .use(router)
    // .use(VueGtag, {
    // config: { id: 'G-XHQ2473ELN' }
    // config: { id: 'GTM-WM5HDDF' }
    // config: { id: 'UA-74266975-2' }
    // }, router)
    .use(dcode)
    .mount('#app')
})
